export { default } from './AppConfirmRegistration';
